<router-outlet></router-outlet>
<ngx-spinner 
    bdColor = "rgba(0, 0, 0, 0.8)" 
    size = "default" 
    color = "#fff" 
    type = "ball-beat" 
    [fullScreen] = "true">
    <p style="font-size: 20px; color: white"> {{common.loadingText}} </p>
</ngx-spinner>